import React, { useState } from "react";
import { History, RotateCcw, ChevronDown, ChevronUp } from "lucide-react";

const fmtTime = (iso) => {
  try {
    return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};

const fmtDate = (d) => {
  if (!d) return "";
  const [y, m, day] = String(d).slice(0, 10).split("-");
  return `${day}/${m}/${y}`;
};

export const RemovedCategoriesPanel = ({ items, availableUntil, onRestore, onRestoreAll, busyId }) => {
  const [open, setOpen] = useState(true);
  if (!items?.length) return null;
  return (
    <div className="card mb-4" data-testid="removed-categories-panel">
      <button
        type="button"
        className="w-full flex items-center justify-between gap-3 p-3 text-left"
        onClick={() => setOpen((o) => !o)}
        data-testid="removed-categories-toggle"
      >
        <span className="flex items-center gap-2">
          <History size={15} className="text-[#C9A84C]" />
          <span className="overline">Categorias removidas ({items.length})</span>
        </span>
        <span className="flex items-center gap-3 text-[11px] text-[var(--text-secondary)]">
          {availableUntil && <span>Restauração disponível até o fim do dia {fmtDate(availableUntil)}</span>}
          {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </span>
      </button>
      {open && (
        <div className="border-t border-white/5">
          <table className="table-dense">
            <thead>
              <tr>
                <th className="w-16">Nº orig.</th>
                <th>Categoria</th>
                <th className="w-40">Removida em</th>
                <th className="text-right pr-4 w-40">Ação</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} data-testid={`removed-cat-${it.id}`}>
                  <td className="tabular-nums text-[var(--text-secondary)]">{it.ordem_original ?? "—"}</td>
                  <td className="font-medium">{it.nome}</td>
                  <td className="text-xs text-[var(--text-secondary)]">{fmtTime(it.removed_at)}</td>
                  <td className="text-right pr-4 whitespace-nowrap">
                    <button
                      type="button"
                      className="btn-ghost !py-1 !px-2.5 !text-xs inline-flex items-center gap-1"
                      onClick={() => onRestore(it)}
                      disabled={Boolean(busyId)}
                      data-testid={`removed-cat-restore-${it.id}`}
                    >
                      <RotateCcw size={12} /> {busyId === it.id ? "Restaurando..." : "Restaurar"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length > 1 && (
            <div className="p-3 flex justify-end border-t border-white/5">
              <button
                type="button"
                className="btn-ghost !py-1.5 !px-3 !text-xs inline-flex items-center gap-1"
                onClick={onRestoreAll}
                disabled={Boolean(busyId)}
                data-testid="removed-cat-restore-all"
              >
                <RotateCcw size={12} /> Restaurar todas
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
